import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const DefaultCardContext = createContext(null);

type Props = {
  children: ReactElement;
};

const DefaultCardProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("billings/cards/set-default", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <DefaultCardContext.Provider value={contextValue}>
      {children}
    </DefaultCardContext.Provider>
  );
};

export default DefaultCardProvider;
